import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Path } from 'config/portal'
import { selectors } from '../reducer'
import { selectors as globalSelectors } from '../../reducer'
import { selectors as apiSelectors } from 'lp-redux-api'
import { selectors as productSelectors } from '../../products/reducer'
import * as apiActions from 'api-actions'
import * as productsActions from '../../products/actions'
import { flashSuccessMessage, flashErrorMessage } from 'redux-flash'
import SharedCompletePlanAgreementView from '../../products/views/CompletePlanAgreementView'

function CompletePlanAgreementView(props) {
  return (
    <SharedCompletePlanAgreementView
      {...props}
      emptyFormRedirectPath={Path.ADD_NEW_BD_SERVICES_AGREEMENT}
      successRedirectPath={Path.BD_SERVICES_AGREEMENTS}
      isBenefitDistribution={true}
    />
  )
}

function mapStateToProps(state) {
  return {
    transformedPlanSponsors: selectors.transformedPlanSponsors(state),
    transformedTpas: selectors.transformedTpas(state),
    transformedConsultants: selectors.transformedConsultants(state),
    availableInitialInvestments:
      productSelectors.availableInitialInvestments(state),
    completeServicesAgreementForm:
      selectors.completeServicesAgreementForm(state),
    currentUser: globalSelectors.currentUser(state),
    isSubmittingServicesAgreementForm: apiSelectors.isLoading(
      state,
      apiActions.submitServicesAgreementForm
    ),
  }
}

const mapDispatchToProps = {
  flashSuccessMessageHandler: flashSuccessMessage,
  flashErrorMessageHandler: flashErrorMessage,
  fetchAvailableInitialInvestments: apiActions.fetchAvailableInitialInvestments,
  fetchPlanSponsors: apiActions.fetchPlanSponsors,
  fetchTpas: apiActions.fetchTpas,
  fetchConsultants: apiActions.fetchConsultants,
  fetchRecordkeepers: apiActions.fetchRecordkeepers,
  submitServicesAgreementForm: apiActions.submitServicesAgreementForm,
  setShouldTriggerAllServicesAgreementsFetch:
    productsActions.setShouldTriggerAllServicesAgreementsFetch,
  setShouldTriggerAllBDPlanAgreementsFetch:
    productsActions.setShouldTriggerAllBDPlanAgreementsFetch,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  CompletePlanAgreementView
)
